module.exports = __webpack_public_path__ + "static/media/FoxHead.3836f013.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/FoxHead.svg
// module id = 109
// module chunks = 0